import React from "react";
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { GraphicStorageGraphicsSubPage, GraphicStorageStandsSubPage } from 'components/pages/graphic-storage';


const GraphicStorageDetailRoute = ({ graphicStorage, history }) => {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }/graphics` }>
                <GraphicStorageGraphicsSubPage graphicStorage={ graphicStorage } />
            </Route>
            <Route path={ `${ path }/stands` } >
                <GraphicStorageStandsSubPage graphicStorage={ graphicStorage } />
            </Route>
            {/* <Route path={ `${ path }` }>
                <div>
                    <h2>Overview Page</h2>
                    <p>This is the overview page for { graphicStorage?.title }</p>
                </div>
            </Route> */}
        </Switch>
    );
};

export default GraphicStorageDetailRoute;
